import React from 'react'
import './style.css'

export const LoaderComponent = () => {
    return (
        <div className="lds-dual-ring"></div>
    )
}

export default LoaderComponent